import React from 'react'
import Container from 'react-bootstrap/Container'
import { useNavigate } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Button from 'react-bootstrap/Button'

function NavBarUsuario() {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('token')
    navigate('/', { replace: true })
  }

  return (
    <Navbar expand="lg" style={{ backgroundColor: '#eaf5fb' }}>
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Button
            onClick={handleLogout}
            style={{
              fontSize: '24px',
              padding: '15px 30px',
              backgroundColor: 'red',
              color: 'white',
              border: '2px solid black',
              fontWeight: 'bold',
              borderRadius: '8px'
            }}
          >
            SAIR
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default NavBarUsuario
